<div class="head-component my-8">
  <p>{{ title }}</p>
</div>
